export const POLLING_INTERVAL = 50000;
export const LOAD_MORE_INCREMENTER = 100;
export const ORDER_TYPES = {
  SITE_DIGITIZATION: 'site_digitization',
};
export const RAPTOR_MAPS_DOCS_URL = 'https://raptormaps.com/solar-tech-docs/';
